import PropTypes from 'prop-types';

// For more info, please refer to MaterialUI's theme object:
// https://material-ui.com/customization/default-theme.
const themePropTypes = PropTypes.shape({
  palette: PropTypes.shape({
    type: PropTypes.string, // light/dark
    primary: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    secondary: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    error: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    warning: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    info: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    success: PropTypes.shape({
      light: PropTypes.string,
      main: PropTypes.string,
      dark: PropTypes.string,
      contrastText: PropTypes.string,
    }),
    text: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
      disabled: PropTypes.string,
      hint: PropTypes.string,
    }),
    background: PropTypes.shape({
      paper: PropTypes.string,
      default: PropTypes.string,
    }),
  }),
  shape: PropTypes.shape({
    borderRadius: PropTypes.number,
  }),
});

export default themePropTypes;
